import "./index.scss";

export const CheckoutSummaryPill = ({ text }) => (
  <div className="checkout-summary-pill" data-testid="checkout-summary-pill">
    {text}
  </div>
);
